import React from 'react';
import Icon from '../../../components/AppIcon';

const SamplePostCard = ({ reactions, timestamp }) => {
  return (
    <div className="bg-card rounded-xl md:rounded-2xl p-5 md:p-6 lg:p-8 shadow-sm border border-border transition-therapeutic hover:shadow-md">
      {/* Blurred content to show privacy */}
      <div className="space-y-4 mb-6">
        <div className="h-4 bg-muted rounded animate-pulse blur-sm"></div>
        <div className="h-4 bg-muted rounded animate-pulse blur-sm w-5/6"></div>
        <div className="h-4 bg-muted rounded animate-pulse blur-sm w-4/6"></div>
        <div className="h-4 bg-muted rounded animate-pulse blur-sm w-3/6"></div>
      </div>
      {/* Timestamp */}
      <div className="flex items-center gap-2 mb-4 text-xs md:text-sm text-muted-foreground">
        <Icon name="Clock" size={14} color="currentColor" strokeWidth={2} />
        <span>{timestamp}</span>
      </div>
      {/* Reaction counts */}
      <div className="flex flex-wrap items-center gap-3 md:gap-4 pt-4 border-t border-border">
        <div className="flex items-center gap-2 px-3 py-2 bg-primary/10 rounded-lg">
          <Icon name="Heart" size={16} color="var(--color-primary)" strokeWidth={2} />
          <span className="text-xs md:text-sm font-medium text-foreground">{reactions?.relate}</span>
        </div>
        
        <div className="flex items-center gap-2 px-3 py-2 bg-success/10 rounded-lg">
          <Icon name="ThumbsUp" size={16} color="var(--color-success)" strokeWidth={2} />
          <span className="text-xs md:text-sm font-medium text-foreground">{reactions?.correct}</span>
        </div>
        
        <div className="flex items-center gap-2 px-3 py-2 bg-warning/10 rounded-lg">
          <Icon name="AlertCircle" size={16} color="var(--color-warning)" strokeWidth={2} />
          <span className="text-xs md:text-sm font-medium text-foreground">{reactions?.notBest}</span>
        </div>
      </div>
    </div>
  );
};

export default SamplePostCard;